import Fa from "./fa/alert.js";
import En from "./en/alert.js";

let language = localStorage.getItem("selectedLanguage");
let alert;
if(language && language === "En"){
  alert = En;
}
else{
  alert = Fa;
}

export default alert;
